import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-detected-encounters',
	templateUrl: './icon-detected-encounters.component.svg',
})
export class IconDetectedEncountersComponent {}
